export const generalFaqs = [
  {
    q: "In welke regio is Koning Aannemersbedrijf actief?",
    a: "Wij werken in heel Zuid-Holland — onder andere Rotterdam, Den Haag, Delft, Leiden, Zoetermeer, Dordrecht en alle dorpen en steden daartussenin. Buiten Zuid-Holland is mogelijk in overleg.",
  },
  {
    q: "Werken jullie met vaste prijzen?",
    a: "Ja. Na een gratis intake en opname maken wij een gedetailleerde offerte met vaste prijs. Wijzigingen tijdens het project worden vooraf schriftelijk vastgelegd zodat u nooit voor verrassingen komt te staan.",
  },
  {
    q: "Hoe lang duurt het voordat ik een offerte heb?",
    a: "Binnen één werkdag nemen wij persoonlijk contact met u op. Na een opname ontvangt u doorgaans binnen 5 tot 10 werkdagen een uitgewerkte offerte.",
  },
  {
    q: "Welke garantie krijg ik op het werk?",
    a: "Wij staan achter de kwaliteit van ons werk. U ontvangt bij oplevering schriftelijke garantievoorwaarden. Daarnaast geldt aanvullende fabrieksgarantie op gebruikte materialen en merken. Onze medewerkers zijn VCA-gecertificeerd en werken volgens de geldende veiligheidsnormen.",
  },
  {
    q: "Werken jullie met onderaannemers?",
    a: "Wij werken met een vast uitvoeringsteam. Voor specialistische onderdelen — zoals installatiewerk of dakbedekking — werken wij samen met een vast netwerk van vertrouwde specialistische partners die wij persoonlijk kennen en waar wij al jaren op vertrouwen.",
  },
  {
    q: "Hoe verloopt een typisch traject?",
    a: "1) Vrijblijvend intakegesprek. 2) Opname en ontwerp. 3) Vaste prijsofferte. 4) Planning en uitvoering. 5) Oplevering en nazorg. U heeft één vast aanspreekpunt gedurende het hele traject.",
  },
  {
    q: "Kan ik tijdens de verbouwing in mijn woning blijven wonen?",
    a: "Bij badkamer-, keuken- of zolderrenovaties meestal wel. Bij complete renovaties of cascorenovaties adviseren wij tijdelijke huisvesting — dit bespreken wij vooraf.",
  },
  {
    q: "Welke materialen en merken gebruiken jullie?",
    a: "Wij werken met A-merken zoals Hansgrohe, Villeroy & Boch, Bosch, Sikkens, Schüco, Solido en Mosa. Op verzoek altijd in te wisselen voor uw eigen voorkeursmerk.",
  },
  {
    q: "Kunnen jullie ook het ontwerp verzorgen?",
    a: "Ja. Wij werken samen met interieurarchitecten en kunnen complete ontwerpen, 3D-impressies en moodboards verzorgen.",
  },
];
